import { mapActions, mapGetters, mapState } from 'vuex'
import types from '../../store/globaltypes'

export default {
  name: 'cropfilters',
  components: {},
  props: [],
  data () {
    return {
      filter: null
    }
  },
  computed: {
    ...mapState({
      cropsFilter: state => state.crops.filter
    }),
    ...mapGetters({
      cropGroups: types.crops.getters.cropgroups
    })
  },
  mounted () {
    this.filter = this.cropGroups.indexOf(this.cropsFilter) + 1
  },
  methods: {
    ...mapActions({
      filterCrops: types.crops.actions.filter
    })
  },
  watch: {
    filter: function (val) {
      if (val) this.filterCrops(this.cropGroups[val - 1])
      else this.filterCrops(null)
    }
  }
}
